import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { Observable } from 'rxjs';

export interface BannerItem {
  id: number;
  lang: string;

  title: string;
  url: string;

  target: number | string; // 0/1 ან '_self'/'_blank'

  // optional (შენ გინდა null იყოს)
  src?: string | null;     // DB column: src
  width?: number | null;
  height?: number | null;

  visible?: number;        // 0/1
  sort?: number;
  pos?: number;
  place?: string | null;
}

@Injectable({ providedIn: 'root' })
export class BannerService {
  private api = environment.apiUrl;

  constructor(private http: HttpClient) {}

  list(params: { lang: string; search?: string; visible?: 'all' | 0 | 1 | '0' | '1' }) {
    return this.http.get<{ status: string; data: BannerItem[] }>(`${this.api}admin/banners`, {
      params: {
        lang: params.lang,
        search: params.search ?? '',
        visible: (params.visible ?? 'all') as any,
      },
    });
  }

  show(id: number, lang: string) {
    return this.http.get<{ status: string; data: BannerItem }>(`${this.api}admin/banners/${id}`, {
      params: { lang },
    });
  }

  create(body: Partial<BannerItem>) {
    return this.http.post<{ status: string; data: BannerItem }>(`${this.api}admin/banners`, body);
  }

  update(id: number, body: Partial<BannerItem>) {
    return this.http.post<{ status: string; data: BannerItem }>(`${this.api}admin/banners/${id}`, body);
  }

  toggleVisible(id: number, lang: string) {
    return this.http.post<{ status: string; visible: number }>(
      `${this.api}admin/banners/${id}/toggle-visible`,
      {},
      { params: { lang } }
    );
  }

  delete(id: number, lang: string) {
    return this.http.post<{ status: string; message: string }>(
      `${this.api}admin/banners/${id}/delete`,
      {}, // <-- soft აღარ გაგზავნო
      { params: { lang } }
    );
  }

  sort(lang: string, ids: number[]) {
    return this.http.post<{ status: string }>(`${this.api}admin/banners/sort`, { lang, ids });
  }
}